<div>
  <h4 class="header-title">{{ tab_name }}</h4>

  <p class="header-subtitle">
    Quant IP's Thematic Clusters make it possible to identify trending technology themes at the right stage of their life-cycle, and to quantify the exposure of a company to them. Below is the breakdown of exposure of {{ tab_name }} across technologies in different stages.
  </p>
  <p>
    Every technology area can be categorized into one of the four stages of the technology lifecycle (emerging, accelerating, maturing and declining). Stocks of the top companies that are most exposed to technologies at the Accelerating Stage have historically outperformed the market by +3% p.a. over the last 10 years.
  </p>
  <p>
    The graph below displays the exposure of {{ tab_name }} to each stage based on recent innovation activity within the last 12 months. The percentage values are based on the number of new inventions published by the company.
  </p>

  <!-- Hero: stage stat cards + lifecycle bar -->
  <div class="chart-card hero-card">
    <div class="card-header-row">
      <h3 class="chart-title">Exposure to Technology Stages</h3>
      <span class="hero-hint" *ngIf="showChart">Click a stage to filter the table below</span>
    </div>

    <div class="stage-grid" *ngIf="showChart">
      <button
        type="button"
        class="stage-card"
        *ngFor="let s of stageStats"
        [class.active]="activeFilter === s.stage"
        [class.is-empty]="s.count === 0"
        [style.border-top-color]="s.color"
        [disabled]="s.count === 0"
        (click)="toggleStage(s.stage)"
        [matTooltip]="s.count === 0 ? 'No technologies in this stage' : 'Filter table by ' + s.stage">
        <div class="stage-pct">{{ s.pct | number:'1.1-1' }}%</div>
        <div class="stage-label" [style.color]="s.color">{{ s.stage }}</div>
      </button>
    </div>

    <div class="lifecycle-bar" *ngIf="showChart">
      <canvas baseChart
        [data]="chartjsData"
        [options]="chartjsOptions"
        [plugins]="chartPlugins"
        [type]="'bar'"></canvas>
    </div>
  </div>

  <!-- Table -->
  <div class="chart-card table-card">
    <div class="card-header-row">
      <h3 class="chart-title">Technology Summary</h3>
      <div class="filter-reset" *ngIf="activeFilter !== 'All'">
        <span>
          Showing only
          <span class="filter-reset-stage" [style.color]="getStageColor(activeFilter)">{{ activeFilter }}</span>
        </span>
        <button type="button" class="reset-btn" (click)="applyFilter('All')">
          <i class="bi bi-x-circle"></i> View all
        </button>
      </div>
    </div>

    <app-loading-progress
      [active]="showSpinner"
      title="Building technology summary"
      [stages]="LOADING_STAGES"
      [estimateSeconds]="30"
      [trackingKey]="tabId + ':company_tech'"
      hint="This can take a little while for large portfolios.">
    </app-loading-progress>

    <div *ngIf="loadingFailed && !showSpinner" class="empty-state">
      <div class="empty-state-icon"><i class="bi bi-exclamation-circle"></i></div>
      <h5>No data available</h5>
      <p>Technology summary data could not be loaded.</p>
    </div>

    <div *ngIf="showTable && !showSpinner && !loadingFailed">
      <div *ngIf="filteredRows.length === 0" class="empty-state">
        <div class="empty-state-icon"><i class="bi bi-search"></i></div>
        <h5>No technologies in this stage</h5>
        <p>Try selecting a different stage above.</p>
      </div>

      <table class="table" *ngIf="filteredRows.length > 0">
        <thead>
          <tr>
            <th style="width:40%">Technologies</th>
            <th style="width:25%">Exposure (%, 12m)</th>
            <th style="width:25%">S-Curve Stage</th>
            <th style="width:10%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedRows">
            <td class="cell-cluster">{{ row.cluster_name }}</td>
            <td>{{ row.exposure | number:'1.2-2' }}%</td>
            <td>
              <span class="stage-badge"
                [style.background-color]="getStageBgColor(row.stage_name)"
                [style.color]="getStageColor(row.stage_name)">
                {{ row.stage_name }}
              </span>
            </td>
            <td>
              <div class="action-buttons">
                <button class="action-btn action-btn-primary"
                  (click)="openCompanyThemePopup(row)"
                  matTooltip="Preview {{ tab_name }}'s activity in this theme">
                  <i class="bi bi-search"></i>
                  <span>View</span>
                </button>
                <button class="action-btn action-btn-icon"
                  (click)="submitTheme(row)"
                  matTooltip="Open theme in a new tab">
                  <i class="bi bi-box-arrow-up-right"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="paginator" *ngIf="totalPages > 1">
        <button class="page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <button *ngFor="let p of pageNumbers"
          class="page-btn"
          [class.active]="p === currentPage"
          (click)="goToPage(p)">
          {{ p + 1 }}
        </button>
        <button class="page-btn" [disabled]="currentPage === totalPages - 1" (click)="goToPage(currentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
        <span class="page-info">{{ filteredRows.length }} technologies</span>
      </div>
    </div>
  </div>
</div>
